<div class="receipts-tab">
  <div *ngIf="isLoading" class="loading">
    <mat-spinner diameter="32"></mat-spinner>
  </div>

  <div *ngIf="!isLoading && loadError" class="error">{{ loadError }}</div>

  <div *ngIf="!isLoading && !loadError && payments.length === 0" class="empty">
    No payments on record for this account.
  </div>

  <table mat-table [dataSource]="payments"
         *ngIf="!isLoading && !loadError && payments.length > 0" class="receipts-table">

    <ng-container matColumnDef="paymentDate">
      <th mat-header-cell *matHeaderCellDef>Date</th>
      <td mat-cell *matCellDef="let p">{{ p.paymentDate | date:'MM/dd/yyyy' }}</td>
    </ng-container>

    <ng-container matColumnDef="receiptNumber">
      <th mat-header-cell *matHeaderCellDef>Confirmation #</th>
      <td mat-cell *matCellDef="let p">{{ p.receiptNumber }}</td>
    </ng-container>

    <ng-container matColumnDef="totalPayment">
      <th mat-header-cell *matHeaderCellDef>Amount</th>
      <td mat-cell *matCellDef="let p">{{ p.totalPayment | currency }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let p">{{ p.status }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let p">
        <button mat-icon-button color="primary" (click)="openReceipt(p)"
                aria-label="Open receipt" title="Open receipt">
          <mat-icon>receipt_long</mat-icon>
        </button>
        <button mat-icon-button (click)="requestRefund(p)" [disabled]="!canRefund(p)"
                aria-label="Request refund"
                [title]="canRefund(p) ? 'Request a refund on this payment' : 'Nothing left to refund'">
          <mat-icon>undo</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <!-- Refunds: request -> approve -> process (or reject). Backend: /api/admin/payments/…/refund -->
  <div class="refunds" *ngIf="!isLoading && !loadError && (refunds.length > 0 || refundError)">
    <h3 class="refunds__title"><mat-icon>undo</mat-icon> Refunds</h3>
    <div *ngIf="refundError" class="error">{{ refundError }}</div>

    <table mat-table [dataSource]="refunds" class="receipts-table" *ngIf="refunds.length > 0">
      <ng-container matColumnDef="refundNumber">
        <th mat-header-cell *matHeaderCellDef>Refund #</th>
        <td mat-cell *matCellDef="let r">{{ r.refundNumber }}</td>
      </ng-container>
      <ng-container matColumnDef="receipt">
        <th mat-header-cell *matHeaderCellDef>Receipt</th>
        <td mat-cell *matCellDef="let r">{{ receiptFor(r) }}</td>
      </ng-container>
      <ng-container matColumnDef="requestedAt">
        <th mat-header-cell *matHeaderCellDef>Requested</th>
        <td mat-cell *matCellDef="let r">{{ r.requestedAt | date:'MM/dd/yyyy' }} <span class="muted">{{ r.requestedByName }}</span></td>
      </ng-container>
      <ng-container matColumnDef="refundAmount">
        <th mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let r">{{ r.refundAmount | currency }} <span class="muted">{{ r.refundType | titlecase }}</span></td>
      </ng-container>
      <ng-container matColumnDef="refundMethod">
        <th mat-header-cell *matHeaderCellDef>Method</th>
        <td mat-cell *matCellDef="let r">{{ r.refundMethod === 'ORIGINAL_METHOD' ? 'Original method' : r.refundMethod }}<span *ngIf="r.checkNumber" class="muted"> #{{ r.checkNumber }}</span></td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let r">
          <span class="refund-status" [class]="'refund-status refund-status--' + r.status.toLowerCase()">{{ r.status | titlecase }}</span>
          <div class="muted" *ngIf="r.status === 'REJECTED' && r.notes">{{ r.notes }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="refundActions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let r">
          <ng-container *ngIf="busyRefundId !== r.id; else busy">
            <button mat-stroked-button color="primary" *ngIf="r.status === 'PENDING'" (click)="approve(r)">Approve</button>
            <button mat-flat-button color="primary" *ngIf="r.status === 'APPROVED'" (click)="process(r)">Process</button>
            <button mat-button color="warn" *ngIf="r.status === 'PENDING' || r.status === 'APPROVED'" (click)="reject(r)">Reject</button>
          </ng-container>
          <ng-template #busy><mat-spinner diameter="18"></mat-spinner></ng-template>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="refundColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: refundColumns;"></tr>
    </table>
  </div>
</div>
